import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import ClusterNavigation from './components/ClusterNavigation';
import QuickLeadSection from './components/QuickLeadSection';
import WhatIsIPR from './components/WhatIsIPR';
import WhyCompanyNeedsIPR from './components/WhyCompanyNeedsIPR';
import WhenNeeded from './components/WhenNeeded';
import IPRComponents from './components/IPRComponents';
import GoodIPRExamples from './components/GoodIPRExamples';
import HowIPRFormed from './components/HowIPRFormed';
import IPRForDifferentRoles from './components/IPRForDifferentRoles';
import WhoResponsible from './components/WhoResponsible';
import IPRAndTraining from './components/IPRAndTraining';
import IPRAndCorporateTraining from './components/IPRAndCorporateTraining';
import WhyProgramsWork from './components/WhyProgramsWork';
import CompanyResults from './components/CompanyResults';
import WorkFormats from './components/WorkFormats';
import ClusterConnection from './components/ClusterConnection';
import AboutTrainer from './components/AboutTrainer';
import StudyFurtherSection from './components/StudyFurtherSection';
import LeadMagnetBlock from '@/components/leadmagnet/LeadMagnetBlock';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '@/components/feature/Footer';

const hubNavLinks = [
  { label: 'Задачи', target: 'tasks' },
  { label: 'Структура ИПР', target: 'structure' },
  { label: 'Форматы', target: 'formats' },
  { label: 'FAQ', target: 'faq' },
];

export default function IPRPage() {
  return (
    <>
      
      <SeoTitle title="Индивидуальный план развития | Business Training" />
      <PageJsonLd />

      <div className="min-h-screen bg-white font-['Inter']">
        <Navbar
          links={hubNavLinks}
          ctaLabel="Заказать тренинг"
          ctaTarget="contact"
        />
        <HeroSection />

        <div id="cluster">
          <ClusterNavigation />
        </div>

        <QuickLeadSection />
        <WhatIsIPR />

        <div id="tasks">
          <WhyCompanyNeedsIPR />
        </div>

        <WhenNeeded />

        <div id="structure">
          <IPRComponents />
        </div>

        <GoodIPRExamples />
        <HowIPRFormed />
        <IPRForDifferentRoles />
        <WhoResponsible />
        <IPRAndTraining />
        <IPRAndCorporateTraining />
        <WhyProgramsWork />
        <CompanyResults />

        <div id="formats">
          <WorkFormats />
        </div>

        <ClusterConnection />
        <AboutTrainer />
        <LeadMagnetBlock variant="compact" />
        <StudyFurtherSection />
        <FAQSection />
        <CTASection />
        <Footer />
      </div>
    </>
  );
}